import axiosInstance from "../../../utils/axiosInstance"
import { BASE_URL, API_ENDPOINT_SUNBURST_DATA } from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

const sunBurstData = createAsyncThunk("dashboard/sunburst", async (data, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}${API_ENDPOINT_SUNBURST_DATA}`, data);
    const responseData = await res.data;
    return responseData;
  } catch (error) {
    return thunkAPI?.rejectWithValue(error?.response?.data);
  }
});
export { sunBurstData };
